import { LeaveRulesScreen } from '../features/leaveRules/LeaveRulesScreen';

export const LeavePage = () => <LeaveRulesScreen />;
